import arrayMutators from 'final-form-arrays';
import React from 'react';
import { Form } from 'react-final-form';
import { useHistory } from 'react-router-dom';
import Button from '../../components/Button';
import { FormSection, FormSectionBody, FormSectionHeader, StyledForm } from '../../components/Form';
import { ROUTES } from '../../routes/routes';

interface Props<T> {
    name: string;
    onSave: (configuration: T) => void;
    onDelete?: () => Promise<void>;
    initialValues: T;
    render: (props: { push: (...args: any[]) => void; values: T }) => React.ReactNode;
}

export default function ConfigurationForm<T>({ name, onSave, onDelete, initialValues, render }: Props<T>) {
    const history = useHistory();

    const handleBack = () => {
        history.push(ROUTES.INTEGRATIONS);
    };

    const handleDelete = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        e.stopPropagation();
        window.confirm('Are you sure you want to delete this integration?') && onDelete?.().then(handleBack);
    };

    return (
        <Form<T>
            onSubmit={onSave}
            initialValues={initialValues}
            mutators={{
                ...(arrayMutators as any),
            }}
        >
            {({
                handleSubmit,
                submitting,
                invalid,
                form: {
                    mutators: { push },
                },
                values,
            }) => (
                <>
                    <StyledForm onSubmit={handleSubmit} className="w-full mt-4 shadow">
                        <FormSection>
                            <FormSectionHeader>{name}</FormSectionHeader>
                            <FormSectionBody>
                                {render({ push, values })}
                                <div className="flex mt-8 space-x-2 justify-end">
                                    <Button type="button" kind="secondary" onClick={handleBack}>
                                        Back to Integrations
                                    </Button>

                                    {onDelete && (
                                        <Button type="button" kind="outline" onClick={handleDelete}>
                                            Remove Integration
                                        </Button>
                                    )}

                                    <Button
                                        type="submit"
                                        kind="primary"
                                        state={submitting ? 'SAVING' : 'READY'}
                                        disabled={invalid}
                                    >
                                        Save
                                    </Button>
                                </div>
                            </FormSectionBody>
                        </FormSection>
                    </StyledForm>
                </>
            )}
        </Form>
    );
}
